<template>
  <aside>
    <b-navbar toggleable class="inner-left-sidebar">
      <!-- <div class="full-width">
    <router-link tag="button" type="button" class="navbar-toggler" :to="{ name: 'practice_dashboard' }" exact>
      <span :class="{ 'active': $route.name === 'practice_dashboard' }">Dashboard</span>
    </router-link>
  </div> -->

      <div class="full-width dropdown">
        <b-navbar-toggle id="administration_dd_btn" target="administration"
          v-if="loginUser.Status == 'PDC' || loginUser.Status == 'PCA'">
          <template #default="{ expanded }">
            <span :class="{
              active:
                $route.name === 'practice_setting' ||
                $route.name === 'billing_information' ||
                $route.name === 'renew_membership' ||
                $route.name === 'focuses' ||
                $route.name === 'focuses_success_report' ||
                $route.name === 'admin_system',
            }">Administration</span>
            <i v-if="expanded" class="fa fa-chevron-right"></i>
            <i v-else class="fa fa-chevron-right"></i>
          </template>
        </b-navbar-toggle>
        <b-collapse id="administration" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item v-if="loginUser.Status == 'PDC'" :to="{ name: 'practice_setting' }">Practice
              Settings</b-nav-item>
            <b-nav-item v-if="loginUser.Status == 'PDC'" :to="{ name: 'billing_information' }">Billing
              Information</b-nav-item>
            <b-nav-item v-if="loginUser.Status == 'PDC'" :to="{ name: 'renew_membership' }">Renew
              Membership</b-nav-item>
            <template v-if="loginUser.MemberStatus == 'Active'">
              <b-nav-item :to="{ name: 'focuses' }">Focuses</b-nav-item>
            </template>
            <template v-if="
              loginUser.userID == 1 ||
              loginUser.userID == 2 ||
              loginUser.userID == 3 ||
              loginUser.Status == 'PCA'
            ">
              <template v-if="loginUser.Status == 'PDC'">
                <b-nav-item :to="{ name: 'focuses_success_report' }">Focuses Success Report</b-nav-item>
              </template>
              <b-nav-item v-if="loginUser.Status == 'PDC'" @click="login()">Admin System</b-nav-item>
            </template>
          </b-navbar-nav>
        </b-collapse>
      </div>

      <div v-if="loginUser.Status == 'PDC'" class="full-width dropdown">
        <b-navbar-toggle id="user_dd_btn" target="modules"
          v-if="loginUser.Status == 'PDC' || loginUser.Status == 'PCA'">
          <template #default="{ expanded }">
            <span :class="{
              active:
                $route.name === 'add_dashboard_user' ||
                $route.name === 'view_dashboard_user' ||
                $route.name === 'edit_dashboard_user' ||
                $route.name === 'single_user' ||
                ($route.name === 'focuses' &&
                  loginUser.MemberStatus === 'Active'),
            }">User</span>
            <i v-if="expanded" class="fa fa-chevron-right"></i>
            <i v-else class="fa fa-chevron-right"></i>
          </template>
        </b-navbar-toggle>
        <b-collapse id="modules" is-nav>
          <b-navbar-nav class="ml-auto">
            <b-nav-item :to="{ name: 'add_dashboard_user' }">Add User</b-nav-item>
            <b-nav-item :to="{ name: 'view_dashboard_user' }" :class="{
              active: $route.matched.some((record) =>
                ['edit_dashboard_user', 'single_user'].includes(record.name)
              ),
            }">View User</b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </div>

      <div class="full-width">
        <router-link tag="button" type="button" class="navbar-toggler" :to="{ name: 'result_calendar' }" exact>
          <span :class="{ active: $route.name === 'result_calendar' }">Input Daily Results</span>
        </router-link>
      </div>

      <div class="full-width" v-if="loginUser.Status == 'PDC' || loginUser.Status == 'PCA'">
        <router-link tag="button" type="button" class="navbar-toggler" :class="{ active: isActive2 }"
          :to="{ name: 'quarter_dashboard' }" exact>
          <span :class="{ active: isActive2 }">Input Practice Goals</span>
        </router-link>
      </div>

      <div class="full-width">
        <router-link tag="button" type="button" class="navbar-toggler" :to="{ name: 'success_report' }" exact>
          <span :class="{ active: $route.name === 'success_report' }">Success Rate Reports</span>
        </router-link>
      </div>

      <div class="full-width">
        <router-link tag="button" type="button" class="navbar-toggler" :to="{ name: 'success_rate' }" exact>
          <span :class="{ active: $route.name === 'success_rate' }">Success Rate Graphs</span>
        </router-link>
      </div>

      <div class="full-width">
        <router-link tag="button" type="button" class="navbar-toggler" :to="{ name: 'daily_report' }" exact>
          <span :class="{ active: $route.name === 'daily_report' }">Daily Reports</span>
        </router-link>
      </div>

      <div class="full-width">
        <router-link tag="button" type="button" class="navbar-toggler" :to="{ name: 'weekly_report' }" exact>
          <span :class="{ active: $route.name === 'weekly_report' }">Weekly Reports</span>
        </router-link>
      </div>

      <div class="full-width" v-if="loginUser.Status == 'PDC'">
        <router-link tag="button" type="button" class="navbar-toggler" :to="{ name: 'calendly_integration' }" exact>
          <span :class="{ active: $route.name === 'calendly_integration' }">Calendly</span>
        </router-link>
      </div>
      <div class="full-width">
        <button type="button" class="navbar-toggler" v-if="loginUser.Status !== 'PDC' && loginUser.is_admin == 1" @click="login">Admin System</button>
      </div>
    </b-navbar>
  </aside>
</template>

<script>
import API from "../../../api";
import userAPI from "../../userApi";
const mixin = {
  methods: {
    addClassesIfActive(routeNames, targetId) {
      const element = document.getElementById(targetId);
      if (!element) return;

      const isActive = routeNames.some((name) =>
        this.$route.matched.some((route) => route.name === name)
      );

      if (isActive) {
        element.classList.add("show");
        element.style.display = "";
      } else {
        element.classList.remove("show");
        element.style.display = "none";
      }

      // Check if the active route belongs to user or administration
      const isUserRoute = routeNames.some((name) =>
        [
          "add_dashboard_user",
          "view_dashboard_user",
          "edit_dashboard_user",
          "single_user",
        ].includes(name)
      );

      let toggleButtonId;
      if (isUserRoute) {
        toggleButtonId = "user_dd_btn";
      } else {
        toggleButtonId = "administration_dd_btn";
      }

      const closestNavbarToggler = document.getElementById(toggleButtonId);

      // Only toggle the classes if the element is active
      if (isActive && closestNavbarToggler) {
        closestNavbarToggler.classList.add("not-collapsed");
        closestNavbarToggler.setAttribute("aria-expanded", "true");
      }
    },

  },
};
export default {
  name: "practiceSidebar",
  mixins: [mixin],
  props: {},
  data() {
    return {
      loginUser: {},
      users: [],
      UserID: "",
      email: "",
      server_url: "",
      url: "",
      remember_be: true,
    };
  },
  methods: {
    login() {
      const params = { id: this.loginUser.userID };
      API.getUserDetails(
        params,
        (resp) => {
          const userDetails = resp.data;
          const userId = userDetails.UserID;
          const userPassword = userDetails.Password;
          const useremail = userDetails.email;

          let email = useremail;
          let password = userPassword;
          let remember_be = this.remember_be;
          let data = {
            email: email,
            password: password,
            client_url: window.location.href,
            remember_be: remember_be,
          };
          this.disabled = true;
          API.login(
            data,
            (data) => {
              if (typeof data.token !== "undefined") {
                // this.$session.set('isLoggedin', data.token);
                localStorage.setItem("isLoggedin", data.token);
                localStorage.setItem(
                  "client_settings",
                  JSON.stringify(data.client_settings)
                );
                localStorage.setItem("user", JSON.stringify(data.user));
                localStorage.setItem(
                  "userPermissions",
                  JSON.stringify(data.permission)
                );
                // this.$session.set('userPermissions', JSON.stringify(data.permission));
                if (this.remember_be == "true") {
                  localStorage.setItem("email", this.email);
                  localStorage.setItem("password", this.password);
                }
                const route = this.$router.resolve({ name: "dashboard" });

                // Open the URL in a new tab
                window.open(route.href, "_blank");
              } else {
                this.$swal({
                  type: "error",
                  title: "Oops...",
                  text: data.message,
                });
              }
            },
            (err) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: err.message,
              });
            }
          );
        },
        (err) => {
          console.error("Error fetching user details:", err);
        }
      );
    },
  },
  computed: {
    isActive2() {
      return (
        ["quarter_dashboard", "input_quarter_goal"].includes(
          this.$route.name
        ) ||
        this.$route.path.startsWith("/quarter_dashboard") ||
        this.$route.path.startsWith("/input_quarter_goal")
      );
    },
    isActive1() {
      return (
        ["scott_notes", "scott_notes_material"].includes(this.$route.name) ||
        this.$route.path.startsWith("/scott_notes") ||
        this.$route.path.startsWith("/scott_notes_material")
      );
    },
  },

  mounted() {
    let user = JSON.parse(localStorage.getItem("userDetails"));
    this.loginUser = user;
    this.$nextTick(() => {
      this.addClassesIfActive(
        [
          "add_dashboard_user",
          "view_dashboard_user",
          "edit_dashboard_user",
          "single_user",
        ],
        "modules"
      );
      this.addClassesIfActive(
        [
          "practice_setting",
          "billing_information",
          "renew_membership",
          "focuses",
          "focuses_success_report",
          "AdminSystem",
        ],
        "administration"
      );
    });
  },
};
</script>
<style>
.navbar-light .navbar-nav .active>.nav-link {
  color: #fbbb29;
  /* Add other styles as needed */
}
</style>